module.exports = "https://static.energy5.com/_next/static/images/perfectChoice-2fe40c85c80892aa05ca39fc2d28bf25.png";